import { handleSettledPromises } from '@kk/shared/utils/async';
import { assertParamsPrescence } from '@kk/shared/utils/validators';
import { useRouteLoaderData } from 'react-router';
import api from '#/api';
import type { RequestOpts } from '#/api/api-types';
import { assertNoLoaderErrors } from '#/api/errors';
import { fetchAllDocumentsQuery } from '#/api/hooks/useAllDocuments';

export type LoaderData = Awaited<ReturnType<typeof loader>>;

export type Params = Record<string, string | undefined>;

export const id = 'signatureOverviewPage' as const;

async function loader({
  params,
  opts,
}: {
  params: Params;
  opts?: RequestOpts;
}) {
  assertParamsPrescence(params);

  const data = await handleSettledPromises([
    fetchAllDocumentsQuery({ filter: api.DocumentStatusFilter.All }, opts),
  ]);

  assertNoLoaderErrors(id, data);
  const [documents] = data;

  return { documents };
}

export const useSignatureOverviewPageLoaderData = () => useRouteLoaderData(id);

export default loader;
